import template from './esignUsageReport.html';
import controller from './esignUsageReportCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    myParam: '<',
  },
};
